import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "../../data/content";
import { ChapterHeading } from "./ChapterHeading";
import { Reveal } from "./Reveal";

const FaqItem = ({ item, index, open, onToggle }) => (
    <div
        data-testid={`faq-item-${index}`}
        className={`rounded-2xl border transition-colors duration-300 ${
            open ? "border-[#00E5FF]/35 bg-[#0D131F]" : "border-white/8 bg-[#0D131F]/60"
        }`}
    >
        <button
            data-testid={`faq-question-${index}`}
            onClick={onToggle}
            aria-expanded={open}
            className="w-full flex items-center justify-between gap-4 px-5 sm:px-6 py-5 text-left"
        >
            <span className="font-display text-base sm:text-lg font-semibold text-white">
                {item.q}
            </span>
            <motion.span
                animate={{ rotate: open ? 45 : 0 }}
                transition={{ duration: 0.3 }}
                className={`shrink-0 h-8 w-8 rounded-full border flex items-center justify-center ${
                    open
                        ? "border-[#F5C518] text-[#F5C518]"
                        : "border-white/15 text-slate-400"
                }`}
            >
                <Plus size={15} />
            </motion.span>
        </button>
        <AnimatePresence initial={false}>
            {open && (
                <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="overflow-hidden"
                >
                    <p
                        data-testid={`faq-answer-${index}`}
                        className="px-5 sm:px-6 pb-5 text-sm text-slate-400 leading-relaxed"
                    >
                        {item.a}
                    </p>
                </motion.div>
            )}
        </AnimatePresence>
    </div>
);

export const Faq = () => {
    const [open, setOpen] = useState(0);
    return (
        <section data-testid="faq-section" className="py-24 lg:py-32 bg-[#0A0E17]/60 border-y border-white/5">
            <div className="px-4 sm:px-6 lg:px-12 max-w-3xl mx-auto">
                <ChapterHeading
                    label="FAQ"
                    title="Questions, Answered"
                    sub="Everything businesses usually ask before starting a project with Animexa."
                    align="center"
                />
                <div className="space-y-3.5">
                    {FAQS.map((item, i) => (
                        <Reveal key={item.q} delay={i * 0.05}>
                            <FaqItem
                                item={item}
                                index={i}
                                open={open === i}
                                onToggle={() => setOpen(open === i ? -1 : i)}
                            />
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
